import EventDescription from './eventDescription/eventDescription.component';
import EventDiscount from './eventDiscount/eventDiscount.component';
import PriceCard from './priceCard/priceCard.component';
import TagsContainer from './tagsContainer/tagsContainer.component';

export { EventDescription, PriceCard, TagsContainer, EventDiscount };
